import { render, staticRenderFns } from "./tabs_profile.vue?vue&type=template&id=3a4e61fa"
import script from "./tabs_profile.vue?vue&type=script&lang=js"
export * from "./tabs_profile.vue?vue&type=script&lang=js"
import style0 from "./tabs_profile.vue?vue&type=style&index=0&id=3a4e61fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports